/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  APPLICATION_VIEW_CORPORATE,
  APPLICATION_VIEW_MASTER,
  APPLICATION_VIEW_OFFICE,
} from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';

import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserDetailsBusinessService } from './resources/user-details-business.service';
import { UserListBusinessService } from './resources/user-list-business.service';

const routes = [
  createRoute({
    component: UserListComponent,
    path: '',
    init: UserListBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
  }),
  createRoute({
    component: UserDetailsComponent,
    path: 'new',
    init: UserDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
      permission: 'Setup.Manager.UserDetails.CREATE',
    },
  }),
  createRoute({
    component: UserDetailsComponent,
    path: ':userId',
    init: UserDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
      permission: [
        'Setup.Manager.UserDetails.EDIT',
        'Setup.Manager.UserDetails.VIEW',
      ],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupUserDetailsRoutingModule {
}
